import _regeneratorRuntime from "/workspace/src/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _toConsumableArray from "/workspace/src/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/workspace/src/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/workspace/src/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

var PersonSet = /*#__PURE__*/function () {
  function PersonSet() {
    var initialPeople = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    _classCallCheck(this, PersonSet);

    this.people = new Map();
    initialPeople.forEach(this.add, this);
  }

  _createClass(PersonSet, [{
    key: "add",
    value: function add(person) {
      this.people.set(person.hashKey(), person);
    }
  }, {
    key: "has",
    value: function has(person) {
      return this.people.has(person.hashKey());
    }
  }, {
    key: "delete",
    value: function _delete(person) {
      this.people.delete(person.hashKey());
    }
  }, {
    key: "equals",
    value: function equals(other) {
      if (!(other instanceof PersonSet)) {
        return false;
      }

      if (this.size !== other.size) {
        return false;
      }

      return _toConsumableArray(other).every(this.has, this);
    }
  }, {
    key: Symbol.iterator,
    value: /*#__PURE__*/_regeneratorRuntime.mark(function value() {
      return _regeneratorRuntime.wrap(function value$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.delegateYield(this.people.values(), "t0", 1);

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, value, this);
    })
  }, {
    key: "size",
    get: function get() {
      return this.people.size;
    }
  }]);

  return PersonSet;
}();

export { PersonSet as default };